import React from 'react';
import Box from '@material-ui/core/Box';

const Rule = () => <Box position="absolute" width="100vw" left={-24} top={0} />;

export default Rule;
